import React from "react";
import { Link } from "react-router-dom";

const CommissionTable = ({ earnings }) => {

    if (!earnings.length) {
        return <p>No earnings available.</p>;
    }

    return (
        <div className="commission-table">

            <table>

                <thead>

                    <tr>

                        <th>Order</th>

                        <th>Provider</th>

                        <th>Total</th>

                        <th>Commission</th>

                        <th>Provider</th>

                        <th>Delivery</th>

                        <th>Status</th>

                        <th>Action</th>

                    </tr>

                </thead>

                <tbody>

                    {earnings.map((earning) => (

                        <tr key={earning._id}>

                            <td>
                                {earning.order?._id?.slice(-6)}
                            </td>

                            <td>
                                {earning.provider?.businessName}
                            </td>

                            <td>
                                ₹{earning.totalAmount}
                            </td>

                            <td>
                                ₹{earning.platformCommission}
                            </td>

                            <td>
                                ₹{earning.providerEarning}
                            </td>

                            <td>
                                ₹{earning.deliveryEarning}
                            </td>

                            <td>
                                {earning.paymentStatus}
                            </td>

                            <td>

                                <Link
                                    to={`/admin/earnings/${earning._id}`}
                                >
                                    View
                                </Link>

                            </td>

                        </tr>

                    ))}

                </tbody>

            </table>

        </div>
    );

};

export default CommissionTable;